"use strict";

Shopify.theme.animation = {
  init: function () {
    $('[data-scroll-class]').waypoint(function () {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, {
      offset: '70%'
    });
  },
  slideTransition: function ($el, animationName, callback) {
    $el.parents('.flickity-enabled').find('.animated').removeClass('animated ' + animationName);
    $el.addClass('animated').addClass(animationName);
  },
  unload: function ($target) {
    $target.data('scroll-class', '');
  }
};
const deferred = {};
Shopify.theme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: (url, view, options = {}) => {
    let data;

    if (url in deferred) {
      return deferred[url];
    }

    const $deferred = $.Deferred();
    deferred[url] = $deferred;

    if (options.hash) {
      data = sessionStorage.getItem(url);

      if (data) {
        const deserialized = JSON.parse(data);

        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    } // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4


    $.ajax({
      url,
      cache: false,
      data: `view=${view}`,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: response => {
        const el = document.createElement('div');
        el.innerHTML = response;
        const responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
        const htmls = el.querySelectorAll('[data-html]');
        let html = {};

        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }

        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html
            }));
          } catch (error) {
            console.error(error);
          }
        }

        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html
        });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    return $deferred.promise();
  }
};

Shopify.theme.addImageDimension = function (imageUrl, size) {
  var insertPosition = imageUrl.lastIndexOf(".");
  return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
};

Shopify.theme.breadcrumbs = {
  init: function (pages) {
    // Show pagination if number of pages is greater than 1
    if (pages > 1) {
      const breadcrumbSpan = document.querySelector('[data-breadcrumb-text]');
      const currentPage = document.querySelector('.paginate').dataset.currentPage ? document.querySelector('.paginate').dataset.currentPage : 1;
      const totalPages = document.querySelector('.paginate').dataset.paginatePages;
      document.querySelector('.js-breadcrumb-text').classList.remove('is-hidden');
      breadcrumbSpan.innerHTML = `${Shopify.translation.page_text} ${currentPage} ${Shopify.translation.of_text} ${totalPages}`;
    }
  },
  unload: function ($target) {
    document.querySelector('.js-breadcrumb-text').classList.add('is-hidden');
  }
};

Shopify.theme.disclosure = {
  enable: function () {
    const $disclosure = $('[data-disclosure]');
    const $toggle = $('[data-disclosure-toggle]');
    const $disclosureWrap = $('.disclosure__list-wrap');
    const $mobileMenuDisclosureList = $('[data-disclosure-list]'); // Check if current opened menu is offscreen

    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }

      $disclosureWrap.removeClass('disclosure--left');
    } // Close menus on ESC


    $('body').on('keyup', function (e) {
      if (e.which == '27') {
        closeDisclosures();
      }
    }); // Close menus on hoverout

    $disclosure.on('mouseleave', function (e) {
      closeDisclosures();
    }); // Close menus on hoverout

    $disclosure.find('.disclosure-list__item:last-child').on('focusout', function (e) {
      closeDisclosures();
    }); // On click/focus event for toggling options

    $toggle.on('mouseenter focus', function (e) {
      // Close all other menus
      closeDisclosures(true, this);
      const $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    }); // Mobile toggle logic

    $mobileMenuDisclosureList.on('touchstart', function (e) {
      const $target = $(e.currentTarget);
      $target.parents('.disclosure').addClass('is-clicked');
      closeDisclosures(true, this);

      if ($target.hasClass('is-clicked') == false) {
        $target.attr('aria-expanded', 'true').addClass('is-clicked');
        checkOffScreen($target);
      } else {
        $target.attr('aria-expanded', 'false').removeClass('is-clicked');
        $disclosureWrap.removeClass('disclosure--left');
      }
    });
    $mobileMenuDisclosureList.on('focusout', function (e) {
      closeDisclosures(true, this);
    }); // Mobile form submitting

    $mobileMenuDisclosureList.on('change', function (e) {
      if (Shopify.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const $target = $(e.currentTarget);
        const selectedValue = e.currentTarget.value;
        const disclosureInput = $target.parents('.selectors-form__item').find('[data-disclosure-input]');
        const selectorForm = $target.parents('.selectors-form');

        if (!$target.hasClass('custom-currency')) {
          disclosureInput.val(selectedValue);
          selectorForm.submit();
        } else {
          $target.trigger('click');
        }
      }
    });
  },
  unload: function () {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
};

Shopify.theme.dropdownMenu = function () {
  // Grab menu items
  const menuItems = $('.navbar-link'); // Grab dropdowns

  const dropdowns = $('.navbar-dropdown'); // Grab megamenus

  const megamenus = $('.has-mega-menu'); // Listen for enter key

  menuItems.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        } // Show dropdown


        $(this).closest('.navbar-item').addClass('show-dropdown'); // Reset itemVisited so that they can visit the link

        itemVisited = true;
      }
    });
    $(item).closest('.navbar-item').on('focusout', function (e) {
      if ($(this).find(e.relatedTarget).length === 0) {
        $(item).closest('.navbar-item').removeClass('show-dropdown');
      }
    });
  }); // Listen for enter key

  dropdowns.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        if ($(this).find('.has-submenu').length > 0) {
          $(this).addClass('show-nested-dropdown');
        } // Reset itemVisited so that they can visit the link


        itemVisited = true;
      }
    });
  }); // Listen for enter key

  megamenus.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        } // Show megamenu


        $(this).find('.mega-menu').addClass('mega-menu--show'); // Reset itemVisited so that they can visit the link

        itemVisited = true;
      }
    }); // Hide mega menu on focusout

    $(item).on('focusout', function (e) {
      if ($(item).find(e.relatedTarget).length === 0) {
        $(item).find('.mega-menu').removeClass('mega-menu--show');
      }
    });
  });
};


Shopify.theme.getSectionData = function ($section) {
  const sectionId = $section.attr('id').replace('shopify-section-', '');
  var $dataEl = $section.find('[data-section-data][data-section-id=' + sectionId + ']').first();
  if (!$dataEl) return {}; // Load data from attribute, or innerHTML

  var data = $dataEl.data('section-data') || $dataEl.html();
  try {
    return JSON.parse(data);
  } catch (error) {
    console.warn(`Sections: invalid section data found. ${error.message}`);
    return {};
  }
};

Shopify.theme.infiniteScroll = {
  init: function () {
    this.defaults = {
      grid: '[data-load-more--grid]',
      gridItems: '[data-load-more--grid-item]'
    };
    $('body').on('click', '[data-load-more]', function (e) {
      e.preventDefault();
      const $button = $(this);
      const url = $button.attr('href');
      Shopify.theme.infiniteScroll.loadNextPage(url, $button);
    });
    $('body').on('click', '[data-load-more-infinite]', function (e) {
      Shopify.theme.infiniteScroll.enableInfinite();
      $(this).remove(); // Prevent link from going to next page

      e.stopPropagation();
      return false;
    });
    this.update()
  },
  update:function(){
    if ($('[data-load-infinite-scroll]').length) {
      Shopify.theme.infiniteScroll.enableInfinite();
    }
  },
  loadNextPage: function (url, $button) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      beforeSend: function () {
        $button.addClass('is-loading');
      },
      success: data => {
        $button.removeClass('is-loading');
        const thumbnails = $(data).find(this.defaults.gridItems);
        const loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $(this.defaults.grid).first().append(thumbnails); // Initialize product reviews

        Shopify.theme.productReviews.init(); // When there are no additional pages, hide load more button

        if (typeof loadMoreButtonUrl == 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error: function (x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      }
    });
  },
  enableInfinite: function () {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(this.defaults.grid)[0],
      items: '[data-load-more--grid-item]',
      more: '[data-load-infinite]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function () {
        $('[data-load-infinite]').removeClass('is-hidden');
      },
      onAfterPageLoad: function (data) {
        // Initialize product reviews
        Shopify.theme.productReviews.init();
      }
    });
  },
  unload: function () {
    $('[data-load-more]').off();
    $('[data-load-infinite]').off();
  }
};

Shopify.theme.flickityIosFix = function () {
  var touchingCarousel = false,
    touchStartCoords;
  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  });
  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };
    if (Math.abs(moveVector.x) > 7) e.preventDefault();
  }, {
    passive: false
  });
};

Shopify.theme.loadScript = function (name, url, callback) {
  if (Shopify.theme[name]) {
    callback;
  } else {
    $.ajax({
      url: url,
      dataType: 'script',
      success: callback,
      async: false
    });
  }
};

Shopify.theme.applyMasonry = function (selector, gutterSize) {
  let $galleryWrapper = $('.gallery-type--masonry');

  if ($galleryWrapper.length > 0) {
    $galleryWrapper.imagesLoaded().progress(function () {
      $galleryWrapper.isotope({
        layoutMode: 'masonry',
        itemSelector: selector,
        percentPosition: true,
        masonry: {
          columnWidth: selector,
          gutter: gutterSize
        }
      });
    });
  }
};

Shopify.theme.applyHorizontalMasonry = function () {
  let $galleryWrapper = $('.gallery-type--horizontal-masonry');
  $galleryWrapper.find('.gallery__item').each(function (e) {
    var wrapper = $(this);
    var imgWidth, imgHeight;
    setTimeout(function () {
      imgWidth = wrapper.find('img').width();
      imgHeight = wrapper.find('img').height();
      wrapper.css("flex-basis", imgWidth * 200 / imgHeight);
      wrapper.css("flex-grow", imgWidth * 200 / imgHeight);
      wrapper.find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    }, 100);
  });
};

Shopify.theme.mobileMenu = {
  init: function () {
    this.$mobileMenuToggle = $('[data-show-mobile-menu]');
    this.$mobileMenuIcon = $('.mobile-menu__toggle-icon');
    this.$mobileDropDownToggle = $('.mobile-menu .close-dropdown');
    $('body').on('click', '[data-show-mobile-menu="false"]', function () {
      Shopify.theme.mobileMenu.open();
      $('#mobile-header').addClass('show-mobile-menu');
      $('html').addClass('mobile-menu-active');
    });
    $('body').on('click', '[data-show-mobile-menu="true"]', function () {
      Shopify.theme.mobileMenu.close();
      setTimeout(function () {
        $('#mobile-header').removeClass('show-mobile-menu');
      }, 500);
      $('html').removeClass('mobile-menu-active');
    });

    if (Shopify.theme.jsHeader.enable_sticky === true) {
      this.enableSticky();
    }
  },
  open: function () {
    //Get current position on page
    let currentScrollPosition = window.scrollY;
    $('body').attr('data-current-position', currentScrollPosition); // Calculate height of mobile content area

    let announcementHeight = 0;
    let mobileHeaderHeight = parseInt($('.mobile-header').outerHeight()) + parseInt($('.top-bar').outerHeight());
console.log(mobileHeaderHeight)
    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    }

    $('.mobile-menu').css({
      height: `calc(100vh - ${mobileHeaderHeight + announcementHeight}px)`
    });
    $('.mobile-menu__content').css({
      marginBottom: `${mobileHeaderHeight + announcementHeight}px`
    });
    this.$mobileMenuIcon.addClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', true);

    if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
      Shopify.theme.jsAjaxCart.hideMiniCart();
      Shopify.theme.jsAjaxCart.hideDrawer();
    } //Set delay on menu open to get proper page position


    setTimeout(function () {
      $('body').addClass('mobile-menu--opened');
    }, 10);
  },
  close: function () {
    $('body').removeClass('mobile-menu--opened'); // Once mobile menu is closed, return back to previous position on page

    let lastScrollPosition = $('body').data('current-position');
    window.scrollTo(0, lastScrollPosition);
    this.$mobileMenuIcon.removeClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', false);
  },
  enableSticky: function () {
    Shopify.theme.jsHeader.disableSticky();
    let $stickyEl = $('#mobile-header');
    let offset = 0;

    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      offset = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    }

    $stickyEl.addClass('sticky--enabled');
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset
    }).on('sticky-start', () => {
      var headerheight = $('#mobile-header').outerHeight();
      var annoucementHeight = $('.announcement-sticky-wrapper').outerHeight();
      var totalHeight = headerheight + annoucementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');
    }).on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%'); // Safety timeout for logo width transition which can throw calculated height off

      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);
      $stickyEl.find('.sticky-menu-wrapper').removeClass('is-visible');
    });
  },
  disableSticky: function () {
    let $stickyEl = $('#mobile-header');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $('.header-sticky-wrapper').css('height', 'auto');
    }, 250);
  },
  unload: function ($section) {
    $('[data-mobilemenu-toggle]').off();
    $('.mobile-menu__toggle-icon').off();
    $('.mobile-menu .close-dropdown').off();
    this.disableSticky();
  }
};

Shopify.money_format = "${{amount}}";

Shopify.formatMoney = function (t, e) {
  function o(t, e) {
    return "undefined" == typeof t ? e : t;
  }

  function i(t, e, i, r) {
    if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
    t = (t / 100).toFixed(e);
    var n = t.split("."),
      a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
      s = n[1] ? r + n[1] : "";
    return a + s;
  }

  "string" == typeof t && (t = t.replace(".", ""));
  var r = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    a = e || this.money_format;

  switch (a.match(n)[1]) {
    case "amount":
      r = i(t, 2);
      break;

    case "amount_no_decimals":
      r = i(t, 0);
      break;

    case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;

    case "amount_with_apostrophe_separator":
      r = i(t, 2);
      break;

    case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      r = i(t, 0, ".", " ");
  }

  return a.replace(n, r);
}

/*============================================================================
Product media controls
==============================================================================*/

Shopify.theme.productMedia = {
  models: [],
  setupMedia: function () {
    const config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      Shopify.theme.productMedia.models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      Shopify.theme.productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};

Shopify.theme.productReviews = {
  init: function () {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      });
    }
  },
  productReviewScroll: function () {
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        Shopify.theme.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  unload: function () {
    $('.spr-badge-container').off();
  }
};

Shopify.theme.quantityBox = {
  init: function () {
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      Shopify.theme.quantityBox.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.quantity-input', function () {
      Shopify.theme.quantityBox.updateQuantity($(this));
    });
  },
  updateQuantityControls: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    let val = parseInt($input.val());
    let valMax = 100000000000000000;

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
  },
  updateQuantity: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    const lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    let valMin = $input.attr('min') || 0;

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }

    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    } // Update quantity if within cart (vs on the product page)


    if ($el.parents('[data-line-item]').length) {
      const lineID = $quantityBox.data('line-item-key');
      Shopify.theme.quantityBox.updateCart(lineID, val);
    } // Call to update quantity controls


    Shopify.theme.quantityBox.updateQuantityControls($el);
  },
  updateCart: function (lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let itemsLeftText = '';
        let quantityWarning = $(`[data-line-item="${lineID}"]`).find('.quantity-warning');
        let $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box');
        let $currentDiscount = $('.cart__form').data('currentDiscount'); //check to see if there are correct amount of products in array

        const cartItemsLineID = lineID - 1;

        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }
        $("[data-line-item='"+lineID+"']  input.quantity-input").attr("data-quantity-value",newQuantity);
        for (let i = 0; i < cart.items.length; i++) {
          if (i != cartItemsLineID) {
            if (cart.items[i].id == cart.items[cartItemsLineID].id) {
              newQuantity += cart.items[i].quantity;
            }
          }
        }

        if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = Shopify.translation.product_count_one;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
              $('.quantity-minus', $quantityBox).attr('disabled', true);
            } else {
              itemsLeftText = Shopify.translation.product_count_other;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
            }
          }
        } //Update total discount value


        $('.cart__form').data('currentDiscount', cart.total_discount); // Apply quantity warning

        quantityWarning.addClass('animated bounceIn');

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.updateView(cart, lineID);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var old__quantity = $("[data-line-item='"+lineID+"']  input.quantity-input").attr("data-quantity-value");
        if($("[data-line-item='"+lineID+"'] .quantity-warning").length > 0){
          $("[data-line-item='"+lineID+"'] .quantity-warning").html(XMLHttpRequest.responseJSON.message);
          $("[data-line-item='"+lineID+"']  input.quantity-input").val(parseInt(old__quantity));
          setTimeout(function(){
            $(".cart__quantity-warning.quantity-warning, .ajax-cart__quantity-warning.quantity-warning").html("");
          }, 1600);
        }
      }
    });
  },
  unload: function ($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};

Shopify.theme.queryParameters = {};

if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');

    if (aKeyValue.length > 1) {
      Shopify.theme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

Shopify.theme.responsiveVideo = {
  init: function () {
    // Find youtube iframes
    var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]'); // For each iframe, if parent is a responsive video wrapper do nothing
    // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

    $videoIframes.each(function (index, iframe) {
      // Update selector
      var $iframe = $(iframe);

      if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
        $iframe.wrap('<div class="lazyframe" data-ratio="16:9"></div>');
      }
    });
  }
};

function selectCallback(productEl, product, variant, state) {
  const $product = $(productEl);
  const $notifyForm = $('.product__notify-form', $product);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');
  const $productFormInput = $productForm.find('.quantity-input');
  const $notifyFormInputs = $('.notify_form__inputs');
  const notifyEmail = Shopify.translation.notify_form_email;
  const notifyEmailValue = Shopify.translation.contact_email;
  const notifySend = Shopify.translation.notify_form_send;
  const notifyUrl = $notifyFormInputs.data('url');
  let notifyMessage = '';
  let notifyEmailInput = '';

  if (variant) {
    if (variant.title != null) {
      // Escape variant titles
      const variantTitle = variant.title.replace(/"/g, '&quot;');
      notifyMessage = `${Shopify.translation.email_content}${variantTitle} | ${notifyUrl}?variant=${variant.id}`;
    }
  } else {
    notifyMessage = `${Shopify.translation.email_content} | ${notifyUrl}`;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${Shopify.translation.customer_email}" />`;
  } else {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }

  const notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`; // Image Variant feature

  // if (variant && variant.featured_image && $product.is(':visible')) {
  //   const $sliders = $('.product-gallery__main, .js-gallery-modal', $product);
  //   $sliders.each((_index, value) => {
  //     const $slider = $(value);
  //     const $sliderInstance = window.Flickity.data(value);
  //     const index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');

  //     if ($slider.is(':visible') && $sliderInstance !== undefined) {
  //       $sliderInstance.select(index, false, true);
  //     }
  //   });
  // } // Emits custom event

  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.product-gallery__main', $product);
    const hasScrollLayout = $sliders.hasClass('product-gallery__scroll');
    const windowWidth = $(window).width();

    if (hasScrollLayout && windowWidth > 798) {
        const $targetImage = $(`img[data-image-id=${variant.featured_media.id}]`, $product);
        
        if ($targetImage.length) {        
            const $imageContainer = $targetImage.closest('.product-gallery__image, .product-image-container');
            
            $('html, body').animate({
                scrollTop: $imageContainer.offset().top - 180
            }, 500);        
        }
    } else {
        $sliders.each((_index, value) => {
            const $slider = $(value);
            const $sliderInstance = window.Flickity.data(value);
            const index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');

            if ($slider.is(':visible') && $sliderInstance !== undefined) {
                $sliderInstance.select(index, false, true);
            }
        });
    }
  }


  const $selectDropdown = $productForm.find('[data-variant-selector]');
  $selectDropdown.trigger('selectedVariantChanged');
  $('.cart-warning', $product).text('');

  if (variant) {
    $('.sku', $product).text(variant.sku);
    $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${variant.title}`);
  }

  if (variant && variant.available) {
    const variantWithInventory = {
      ...variant,
      ...(variantInventory ? variantInventory.find(v => v.id === variant.id) || {} : {})
    };

    if (variantWithInventory.inventory_management && variantWithInventory.inventory_quantity > 0) {
      if (Shopify.theme_settings.display_inventory_left) {
        let itemsLeftText = Shopify.translation.product_count_other;

        if (variantWithInventory.inventory_quantity === 1) {
          itemsLeftText = Shopify.translation.product_count_one;
        }

        const inventoryThreshold = Shopify.theme_settings.inventory_threshold;

        if (variantWithInventory.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variantWithInventory.inventory_quantity} ${itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }

      if (variantWithInventory.inventory_policy === 'deny') {
        $('[data-max-inventory-management]', $product).attr('max', variantWithInventory.inventory_quantity); // Check to see if quantity selector should be disabled based on inventory remaining

        Shopify.theme.quantityBox.updateQuantityControls($productFormInput);
      }
    } else {
      $('.items_left', $product).text('');
      $('[data-max-inventory-management]', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('span:not(.icon)').text($('[data-add-to-cart-trigger]', $product).data('label')); // Initialize shopify payment buttons

    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    $('.shopify-payment-button', $product).show();
    $('.purchase-details__quantity', $product).show();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    $notifyFormInputs.append(notifyFormHTML);

    if (Shopify.theme.currencyConverter) {
      Shopify.theme.currencyConverter.convertCurrencies();
    }
  } else {
    const message = variant ? Shopify.translation.soldOut : Shopify.translation.unavailable;
    $('.items_left', $product).text('');
    $('[data-max-inventory-management]', $product).removeAttr('max');
    $('.sold_out', $product).text(message); // If we haven't selected all options, let the add to cart button be enabled

    if (state === 'not-selected') {
      $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', '').find('span:not(.icon)').text($('[data-add-to-cart-trigger]', $product).data('label'));
    } else {
      $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', null).find('span:not(.icon)').text(message);
    }

    $('.shopify-payment-button', $product).hide();
    $('.purchase-details__quantity', $product).hide();
    $notifyForm.hide();
    $notifyFormInputs.empty();

    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }
}

window.selectCallback = selectCallback;

Shopify.theme.predictiveSearch = {
  vars: {
    term: '',
    searchPath: Shopify.routes.search_url,
    displayTimer: ''
  },
  init: function () {
    this.unload();
    $('[data-show-search-trigger], [data-autocomplete-true] input').on('click touchstart', function (e) {
      if (!isScreenSizeLarge()) {
        e.stopPropagation();
        const formType = $(this).closest('form').find('[name="type"]').val();
        const position = $(document).scrollTop();
        Shopify.theme.predictiveSearch.showMobileSearch(formType, position);
      }
    }); // Focus state to display search results

    $('[data-autocomplete-true]').on('focus', function () {
      $(this).parents('[data-autocomplete-true]').find('.search__results-wrapper').show();
    }); // Clicking outside makes the results disappear.

    $(document).on('click focusout', function (e) {
      if (Shopify.media_queries.large.matches) {
        var searchForm = $(e.target).parents('.search-form');

        if (searchForm.length === 0) {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      }
    }); // Submit wildcard searches

    $("[data-autocomplete-true] form").on("submit", function (e) {
      e.preventDefault();
      const formValue = $(this).find('input[name="q"]').val();
      const cleanFormValue = encodeURI(formValue);
      let searchType = Shopify.theme_settings.search_option;

      if ($(this).find('[name="type"]').length > 0) {
        searchType = $(this).find('[name="type"]').val();
      }

      if (cleanFormValue == null) {
        window.location.href = Shopify.routes.search_url + '?type=' + searchType;
      } else {
        window.location.href = Shopify.theme.predictiveSearch.vars.searchPath + '?type=' + searchType + '&q=' + cleanFormValue + '*';
      }
    });
    $('[data-autocomplete-true] form').each(function () {
      const $this = $(this);
      const input = $this.find('input[name="q"]'); // Adding a list for showing search results.

      const resultWrapper = `
        <div class="search__results-wrapper">
          <h2 class="vertical-search__title">
            ${Shopify.translation.top_suggestions}
          </h2>
          <ul class="search__results"></ul>
        </div>
      `;
      $(resultWrapper).appendTo($this);
      input.attr('autocomplete', 'off').on('input', function () {
        clearTimeout(Shopify.theme.predictiveSearch.vars.displayTimer);

        if ($(this).val().length > 3) {
          Shopify.theme.predictiveSearch.vars.term = $(this).val();
          Shopify.theme.predictiveSearch.getResults(Shopify.theme.predictiveSearch.vars.term, $this);
        } else {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      });
    });
  },
  getResults: function (term, $this) {
    let searchType = Shopify.theme_settings.search_option;

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": searchType,
        "limit": Shopify.theme_settings.search_to_display,
        "options": {
          "unavailable_products": "last",
          "fields": "title,body,variants.title,variants.sku,vendor,product_type,tag"
        }
      }
    }).done(function (response) {
      const suggestions = [response.resources.results.products, response.resources.results.pages, response.resources.results.articles];
      let filteredResults = []; // Store results in array

      $.each(suggestions, function (index, suggestion) {
        if (suggestion !== undefined && suggestion.length > 0) {
          // Ensure suggestion exists
          filteredResults.push(suggestion);
        }
      }); // Display results

      Shopify.theme.predictiveSearch.vars.displayTimer = setTimeout(function () {
        Shopify.theme.predictiveSearch.displayResults(filteredResults[0], $this);
      }, 500);
    });
  },
  displayResults: function (results, $this) {
    const $resultsWrapper = $this.find('.search__results-wrapper');
    const $resultsList = $this.find('.search__results');
    let searchType = Shopify.theme_settings.search_option;
    const comingSoonOrnamentImage = Shopify.theme_settings.coming_soon_ornament_image_url || 'https://2bglass.com/cdn/shop/files/Slice138_a345be13-7d11-403d-80ef-787c1e016d45_400x.png';
    $resultsWrapper.show();
    $resultsList.empty();

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    function normalizeTag(tag) {
      return String(tag || '').toLowerCase().replace(/[_\s]+/g, '-');
    }

    function resultHasTag(result, callback) {
      return Array.isArray(result.tags) && result.tags.some(function (tag) {
        return callback(normalizeTag(tag));
      });
    }

    function isComingSoonOrnamentResult(result) {
      var isComingSoon = resultHasTag(result, function (tag) {
        return tag.indexOf('coming-soon') !== -1 || tag === 'comingsoon';
      });
      var isOrnament = resultHasTag(result, function (tag) {
        return tag === 'ornament' || tag === 'ornaments' || tag.indexOf('ornament') !== -1;
      });

      return isComingSoon && isOrnament;
    }

    if (results && results.length > 0) {
      $.each(results, function (index, result) {
        let link = $('<a tabindex="0"></a>').attr('href', result.url);

        if (Shopify.routes.root_url !== '/') {
          link = $('<a tabindex="0"></a>').attr('href', Shopify.routes.root_url + result.url);
        } // if result is a product


        if (result['price']) {
          function formatPrice(price) {
            return '<span class="money">' + Shopify.formatMoney(price, $('body').data('money-format')) + '</span>';
          }

          let itemPrice;

          if (result.available === true) {
            if (result.compare_at_price_max > result.price_max || result.compare_at_price_min > result.price_min) {
              itemPrice = `${formatPrice(result.price)} <span class="was-price">${formatPrice(result.compare_at_price_max)}</span>`;
            } else {
              if (result.price > 0) {
                if (result.price_min != result.price_max) {
                  itemPrice = `${Shopify.translation.from} ${formatPrice(result.price)}`;
                } else {
                  itemPrice = `${formatPrice(result.price)}`;
                }
              } else {
                itemPrice = Shopify.theme_settings.free;
              }
            }
          } else {
            itemPrice = Shopify.translation.soldOut;
          } // If result has image


          if (result['image']) {
            var resultImage = isComingSoonOrnamentResult(result) ? comingSoonOrnamentImage : Shopify.theme.addImageDimension(result['image'], '_300x');
            link.append(`<div class="thumbnail"><img class="lazyload transition--${Shopify.theme_settings.image_loading_style}" src="${resultImage}" /></div>`);
          }

          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-pricing price">${itemPrice}</span></div>`); // if result is an article
        } else if (result['summary_html']) {
          if (result.image != 'NULL') {
            link.append(`<div class="thumbnail"><img class="lazyload transition--${Shopify.theme_settings.image_loading_style}" src="${Shopify.theme.addImageDimension(result['image'], '_300x')}" /></div>`);
          }

          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-description">'${result.summary_html.replace(/(<([^>]+)>)/ig, "").slice(0, 25)}</span></div>`); // if result is a page
        } else if (result['published_at']) {
          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-description">${result.body.replace(/(<([^>]+)>)/ig, "").slice(0, 25)}</span></div>`);
        } // Wrap link and append to list


        link.wrap('<li class="item-result"></li>');
        $resultsList.append(link.parent());

        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.init();
        }
      });
      $resultsList.prepend(`<li class="all-results"><span class="see-all"><a href="${this.vars.searchPath}?type=${searchType}&q=${this.vars.term}*"> ${Shopify.translation.all_results} ${Shopify.icons.right_caret}</a></span></li>`);
      $resultsList.parents('.search__results-wrapper').addClass('results-found');
    } else {
      // if no results
      const noResults = `<li class="item-result"><span class="no-results">${Shopify.translation.no_results}</span></li>`;
      $resultsList.append(noResults);
      $resultsList.parents('.search__results-wrapper').removeClass('results-found');
    }

    if ($this.parents('.vertical-header__content').length && Shopify.theme.jsHeader.header_layout === 'vertical') {
      Shopify.theme.predictiveSearch.alignVerticalSearch();
    }

    $resultsList.show();
  },
  showMobileSearch: function (formType, position) {
    $('body').css('max-height', window.innerHeight);
    $('.mobile-search').fadeIn(200);

    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      $('.mobile-search input[data-q]').focus();
    } else {
      //Set delay to ensure focus triggers on android
      setTimeout(function () {
        $('.mobile-search input[data-q]').focus();
      }, 205);
    }

    document.body.style.position = 'fixed';
    document.body.style.top = '-' + position + 'px';
    $('.mobile-search').css('top', position);
    const searchHeight = window.innerHeight - 46; //Full screen height - form height

    $('.mobile-search .search__results-wrapper').css('max-height', searchHeight);

    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    } else {
      $('.mobile-search [name="type"]').val(Shopify.theme_settings.search_option);
    }

    $('.search-form .close-search').on('click touchstart', function (e) {
      e.preventDefault();
      e.stopPropagation();
      Shopify.theme.predictiveSearch.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
    });
    $('.search-form .submit-search').on('click touchstart', function (e) {
      $(this).parents('form').submit();
    });
  },
  hideMobileSearch: function (position) {
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position);
    $('.mobile-search').fadeOut(200);
    $('.mobile-search [name="q"]').val('');
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
  },
  alignVerticalSearch: function () {
    const $resultsList = $('.header--vertical .search__results');
    const headerWidth = $('.header--vertical').innerWidth();
    $resultsList.parents('.search__results-wrapper').css({
      'position': 'fixed',
      'left': headerWidth,
      'top': '0'
    });
  },
  unload: function () {
    $('body').off('focus', '[data-autocomplete-true] input');
    $('input[name="q"]').off();
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search__results-wrapper').remove();
  }
};

function isScreenSizeLarge() {
  if (Shopify.media_queries.large.matches) {
    return true;
  }
}

Shopify.theme.scrollToTop = function (element, height) {
  // Check if height argument is present
  if (height != undefined) {
    $('html, body').animate({
      scrollTop: $(element).offset().top - height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 1000);
  }
};

Shopify.theme.handleNewTabLinks = function ($links) {
  if (!$links.length) return;
  $links.each(function (index, link) {
    let href = $(link).attr('href')
    if(Shopify.theme.isExternalLink(href)){
      link.setAttribute('target','_blank')
    }
  })
};

Shopify.theme.isExternalLink = function(link){
  if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
    return true
  }
  return false
};

class ProductCard {
  enableSwatches() {
    // if (window.isScreenSizeLarge()) {
    //   $('body').on('mouseenter', '.swatch span', ({
    //     currentTarget
    //   }) => {
    //     if ($(currentTarget).data('image').indexOf('no-image') === -1) {
    //       $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('src', $(currentTarget).data('image'));
    //       $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('srcset', $(currentTarget).data('image'));
    //     }
    //   });
    // }
  }

  showVariantImage() {
    // if (window.isScreenSizeLarge()) {
    //   $('body').on('mouseenter', '.has-secondary-image-swap', ({
    //     currentTarget
    //   }) => {
    //     const $thumbnailImage = $(currentTarget).find('.product-image__wrapper img');
    //     const $thumbnailVideo = $(currentTarget).find('.product-image__wrapper .video-on-hover');

    //     if ($thumbnailImage) {
    //       $thumbnailImage.toggleClass('swap--visible');
    //     }

    //     if ($thumbnailVideo) {
    //       $thumbnailVideo.toggleClass('swap--visible');
    //       Shopify.theme.video.enableVideoOnHover($(currentTarget));
    //     }
    //   });
    //   $('body').on('mouseleave', '.has-secondary-image-swap', ({
    //     currentTarget
    //   }) => {
    //     const $thumbnailImage = $(currentTarget).find('.product-image__wrapper img');
    //     const $thumbnailVideo = $(currentTarget).find('.product-image__wrapper .video-on-hover');

    //     if ($thumbnailImage) {
    //       $thumbnailImage.toggleClass('swap--visible');
    //     }

    //     if ($thumbnailVideo) {
    //       $thumbnailVideo.toggleClass('swap--visible');
    //       Shopify.theme.video.disableVideoOnHover($(currentTarget));
    //     }
    //   });
    // }
  }

  showQuickShop() {
    // EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      $currentTarget.addClass('is-loading')
      Shopify.theme.jsProductClass.load($currentTarget.data('url')).then(({
        html
      }) => {
        $('.js-quick-shop').html(html.content);
        $('.js-quick-shop .js-product_section').addClass('quickshop');

        if (!$('.fancybox-active').length) {
          $.fancybox.open($('.js-quick-shop'), {
            baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            },
            beforeShow: () => {
              let currentScrollPosition = window.scrollY;
              $('body').attr('data-current-position', currentScrollPosition);
              $('body').addClass('mobile-menu--opened');
            },
            afterShow: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              $currentTarget.removeClass('is-loading')
              const $quickshop = $(src).find('.quick-shop');
              Shopify.theme.jsProduct.init($('.js-quick-shop'));
              $quickshop.addClass('quick-shop--loaded');
              $quickshop.addClass('content-loaded');
            },
            beforeClose: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              $('body').removeClass('mobile-menu--opened');
              let lastScrollPosition = $('body').data('current-position');
              window.scrollTo(0, lastScrollPosition);
              $quickshop.removeClass('quick-shop--loaded');
              $quickshop.removeClass('content-loaded');
            }
          });
        }
      }).catch(error => console.error(e));
    });
  }

}

Shopify.theme.thumbnail = new ProductCard();
const videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [];
let videosInRecommendedProductsPlayer;
Shopify.theme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  setupVideoPlayer: function () {
    const productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    let setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    let videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function (index, player) {
      player.loop = videoLooping;
      videoPlayers.push(player);
    });
    this.setupListeners();
  },
  setupListeners: function () {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      const id = player.id;
      let $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      } // When a video is playing, pause any other instances


      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          var playerID = player.id || player.media.dataset.plyrVideoId;

          if (instance.id != playerID) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  }
};


// custom arrow button on about-us page

// let all_custom_arrow_buttons = document.querySelectorAll('.custom-arrow-button');
// if(all_custom_arrow_buttons.length > 0){
//   all_custom_arrow_buttons.forEach((custom_arrow_button)=>{
//     custom_arrow_button.addEventListener('click', ()=>{
//       let current_btn = custom_arrow_button.getAttribute('aria-label');
//       let main_container = custom_arrow_button.closest('.image-with-text__image-column');
//       if(current_btn == 'Next'){
//         main_container.querySelector('.image-item.top-img').classList.remove('top-img');
//         let bottom_img_item = main_container.querySelector('.image-item.bottom-img');
//         bottom_img_item.classList.add('top-img');
//         bottom_img_item.classList.remove('bottom-img');
//         if(bottom_img_item.nextElementSibling){
//           bottom_img_item.nextElementSibling.classList.add('bottom-img');
//         }
//         else{
//           main_container.querySelector('.image-item').classList.add('bottom-img');
//         }
//       }
//       else if(current_btn == 'Previous'){
//         main_container.querySelector('.image-item.bottom-img').classList.remove('bottom-img');
//         let top_img_item = main_container.querySelector('.image-item.top-img');
//         top_img_item.classList.add('bottom-img');
//         top_img_item.classList.remove('top-img');
//         if(top_img_item.previousElementSibling){
//           top_img_item.previousElementSibling.classList.add('top-img');
//         }
//         else{
//           main_container.querySelector('.image-item:last-child').classList.add('top-img');
//         }
//       }
//     })
//   })
// }

// =======CUSTOM CAROUSEL WITH GSAP SMOOTH ANIMATION========
$(document).ready(() => {
  const customCarouselBodyInit = () => {
    function mod(n, m) {
      return ((n % m) + m) % m;
    }

    function initCustomCarousel($root) {
      const $stage = $root.find(".customCarouselStage");
      const $prevBtn = $root.find(".customCarouselBtn--prev");
      const $nextBtn = $root.find(".customCarouselBtn--next");

      const $sourceItems = $root.find(
        ".customCarouselSlides .customCarouselSlideItem img"
      );
      const images = $sourceItems.map((_, img) => $(img).attr("src")).get();

      if (!images || images.length < 2) return;

      let i = 0;
      let $front = null;
      let $back = null;
      let animating = false;

      function getFrontYOffset() {
        const v = getComputedStyle($root[0])
          .getPropertyValue("--cc-front-y")
          .trim();
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : 0;
      }

      function makeSlide(index) {
        const $el = $(
          `<div class="customCarouselSlide" aria-hidden="true"><img alt=""></div>`
        );
        $el.find("img").attr("src", images[mod(index, images.length)]);
        $stage.append($el);
        return $el;
      }

      function getLayout($el) {
        const stage = $stage[0].getBoundingClientRect();
        const rect = $el[0].getBoundingClientRect();

        const sw = rect.width;
        const sh = rect.height;

        const back = { x: 0, y: 0, scale: 0.92, opacity: 0.9 };

        const front = {
          x: Math.max(0, stage.width - sw),
          y: Math.max(0, stage.height - sh) + getFrontYOffset(),
          scale: 1,
          opacity: 1,
        };

        return {
          back,
          front,
          stageW: stage.width,
          stageH: stage.height,
          sw,
          sh,
        };
      }

      function placeInitial() {
        $stage.empty();
        $front = makeSlide(i);
        $back = makeSlide(i + 1);

        requestAnimationFrame(() => {
          const Lf = getLayout($front);
          const Lb = getLayout($back);

          gsap.set($back, {
            x: Lb.back.x,
            y: Lb.back.y,
            scale: Lb.back.scale,
            opacity: Lb.back.opacity,
            zIndex: 1,
          });
          gsap.set($front, {
            x: Lf.front.x,
            y: Lf.front.y,
            scale: Lf.front.scale,
            opacity: Lf.front.opacity,
            zIndex: 2,
          });
        });
      }

      function relayout() {
        if (!$front || !$back || animating) return;
        const Lf = getLayout($front);
        const Lb = getLayout($back);
        gsap.set($back, { x: Lb.back.x, y: Lb.back.y });
        gsap.set($front, { x: Lf.front.x, y: Lf.front.y });
      }

      function goNext() {
        if (animating) return;
        animating = true;

        const $out = $front;
        const $promote = $back;
        const $incoming = makeSlide(i + 2);

        requestAnimationFrame(() => {
          const Lout = getLayout($out);
          const Lpro = getLayout($promote);
          const Lin = getLayout($incoming);

          gsap.set($incoming, {
            x: -Math.min(40, Lin.sw * 0.12),
            y: -Math.min(40, Lin.sh * 0.12),
            scale: 0.92,
            opacity: 0,
            zIndex: 1,
          });

          gsap.set($out, { zIndex: 3 });
          gsap.set($promote, { zIndex: 2 });

          gsap
            .timeline({
              defaults: { duration: 0.8, ease: "power3.inOut" },
              onComplete: () => {
                $out.remove();
                i = mod(i + 1, images.length);
                $front = $promote;
                $back = $incoming;
                animating = false;
              },
            })
            .to(
              $out,
              {
                x: Lout.front.x + Lout.stageW * 0.65,
                y: Lout.front.y + Lout.stageH * 0.65,
                opacity: 0,
                rotate: 2,
              },
              0
            )
            .to(
              $promote,
              {
                x: Lpro.front.x,
                y: Lpro.front.y,
                scale: 1,
                opacity: 1,
              },
              0
            )
            .to(
              $incoming,
              {
                x: 0,
                y: 0,
                opacity: 0.9,
              },
              0.1
            );
        });
      }

      function goPrev() {
        if (animating) return;
        animating = true;

        const $out = $back; // old back leaves
        const $demote = $front; // old front becomes back
        const $incoming = makeSlide(i - 1); // new front

        requestAnimationFrame(() => {
          const Lout = getLayout($out);
          const Ldem = getLayout($demote);
          const Lin = getLayout($incoming);

          gsap.set($incoming, {
            x: -Math.min(40, Lin.sw * 0.12),
            y: -Math.min(40, Lin.sh * 0.12),
            scale: 0.92,
            opacity: 0,
            zIndex: 3,
          });

          gsap.set($demote, { zIndex: 2 });
          gsap.set($out, { zIndex: 1 });

          gsap
            .timeline({
              defaults: { duration: 0.8, ease: "power3.inOut" },
              onComplete: () => {
                $out.remove();
                i = mod(i - 1, images.length);
                $front = $incoming;
                $back = $demote;
                animating = false;
              },
            })
            .to(
              $out,
              {
                x: Lout.back.x + Lout.stageW * 0.65,
                y: Lout.back.y + Lout.stageH * 0.65,
                opacity: 0,
                rotate: 2,
              },
              0
            )
            .to(
              $demote,
              {
                x: Ldem.back.x,
                y: Ldem.back.y,
                scale: Ldem.back.scale,
                opacity: Ldem.back.opacity,
              },
              0
            )
            .to(
              $incoming,
              {
                x: Lin.front.x,
                y: Lin.front.y,
                scale: 1,
                opacity: 1,
              },
              0.1
            );
        });
      }

      // Bind once per instance
      $nextBtn.off("click.customCarousel").on("click.customCarousel", goNext);
      $prevBtn.off("click.customCarousel").on("click.customCarousel", goPrev);

      // Resize
      $(window).on("resize.customCarousel", relayout);

      placeInitial();
    }

    if ($(".customCarouselContainer").length > 0) {
      $("[data-custom-carousel]").each(function () {
        initCustomCarousel($(this));
      });
    }
  };

  // Init all carousels on the page

  customCarouselBodyInit();
});

// Search bar animation
(function() {
  const $inputs = document.querySelectorAll('.header .input, .mobile-menu .input');

  if ($inputs.length === 0) return;
  
  $inputs.forEach($input => {
    const suggestions = [
      $input.dataset.suggestionOne,
      $input.dataset.suggestionTwo,
      $input.dataset.suggestionThree,
      $input.dataset.suggestionFour
    ].filter(Boolean);
    
    if (!suggestions.length) return;
    
    let idx = 0, charIdx = 0, timer;
    
    function type() {
      $input.placeholder = suggestions[idx].slice(0, ++charIdx);
      if (charIdx < suggestions[idx].length) {
        timer = setTimeout(type, 80);
      } else {
        timer = setTimeout(erase, 1200);
      }
    }
    
    function erase() {
      $input.placeholder = suggestions[idx].slice(0, --charIdx);
      if (charIdx > 0) {
        timer = setTimeout(erase, 40);
      } else {
        idx = (idx + 1) % suggestions.length;
        timer = setTimeout(type, 500);
      }
    }
    
    function stop() {
      clearTimeout(timer);
      $input.placeholder = '';
    }
    
    function start() {
      if (!$input.value.trim() && $input !== document.activeElement) {
        charIdx = 0;
        type();
      }
    }
    
    $input.addEventListener('focus', stop);
    $input.addEventListener('blur', () => setTimeout(start, 500));
    $input.addEventListener('input', stop);
    
    setTimeout(start, 2000);
  });
})();


// PDP scrollbar
$(document).ready(function() {
    var $gallery = $('.product__images');
    var $mediaScroll = $('.product-details__media-scroll');
    var $mediaScrollSpan = $('.product-details__media-scroll span');
    var galleryOffset = $gallery.offset().top;
    var galleryHeight = $gallery.outerHeight();
    var isSticky = false;

    var spanHeight = 40;
    var trackHeight = 240;
    var maxTopPosition = trackHeight - spanHeight;

    function updateScrollSpanPosition(scrollTop) {
        var windowHeight = $(window).height();
        var maxScroll = Math.max(galleryHeight - windowHeight, 1);
        var scrollFromGalleryStart = Math.max(0, scrollTop - galleryOffset);
        var scrollPercentage = Math.min(scrollFromGalleryStart / maxScroll, 1);
        var spanTop = scrollPercentage * maxTopPosition;
        $mediaScrollSpan.css('top', spanTop + 'px');
    }

    function scrollToSpanPosition(spanTop) {
        var windowHeight = $(window).height();
        var maxScroll = Math.max(galleryHeight - windowHeight, 1);
        var scrollPercentage = spanTop / maxTopPosition;
        var targetScroll = galleryOffset + (scrollPercentage * maxScroll);
        $('html, body').animate({ scrollTop: targetScroll }, 240);
    }

    $(window).on('scroll resize', function() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        galleryOffset = $gallery.offset().top;
        galleryHeight = $gallery.outerHeight();
        var shouldBeSticky = scrollTop >= galleryOffset;
        
        if (shouldBeSticky && !isSticky) {
            isSticky = true;
        } else if (!shouldBeSticky && isSticky) {
            isSticky = false;
        }
        
        if (isSticky) {
            updateScrollSpanPosition(scrollTop);
        } else {
            $mediaScrollSpan.css('top', '0px');
        }
    }).trigger('scroll');

    $mediaScroll.on('click', function(e) {
        if (e.target === $mediaScrollSpan[0]) return;
        var trackTop = $mediaScroll.offset().top;
        var clickY = e.pageY - trackTop;
        var targetTop = clickY - (spanHeight / 2);
        targetTop = Math.max(0, Math.min(targetTop, maxTopPosition));
        $mediaScrollSpan.animate({ top: targetTop + 'px' }, 240);
        scrollToSpanPosition(targetTop);
    });
});


// Newsletter input placeholder text hide after adding value
$(document).ready(function() {
  $('.has-icons-left--responsive-form .input')
    .on('input', function() {
      $(this).siblings('span').toggle($(this).val().trim() === '');
    })
    .each(function() {
      $(this).siblings('span').toggle($(this).val().trim() === '');
    });
});

// drawer tos
function tos_label_toggle(e){
  e.target.closest('.tos').querySelector('.tos_agree').click();
}
function tos_input_click(e){
  e.target.closest('.ajax-cart__details-wrapper').classList.toggle('active');
}
function drawer_checkout_btn(e){
  e.preventDefault();
  let tos_condition = e.target.closest('.ajax-cart__details-wrapper').querySelector('.tos_agree');
  let tos_checked = tos_condition.checked;
  if(tos_checked == false){
    e.target.closest('.ajax-cart__details-wrapper').querySelector('.tos-error-msg').classList.add('active');
  }
  else if(tos_checked == true){
    window.location.href = "/checkout";
  }
}

// cart tos
function cart_tos_label_toggle(e){
  e.preventDefault();
  e.target.closest('.field').querySelector('.tos_agree').click();
}
function cart_tos_input_click(e){
  e.target.closest('.cart__footer').classList.toggle('active');
}
function cart_checkout_btn(e){
  e.preventDefault();
  let tos_condition = e.target.closest('.cart__footer').querySelector('.tos_agree');
  let tos_checked = tos_condition.checked;
  if(tos_checked == false){
    e.target.closest('.cart__footer').querySelector('.tos-error-msg').classList.add('active');
  }
  else if(tos_checked == true){
    window.location.href = "/checkout";
  }
}

$('.product-thumbnail__carousel').each(function () {
  var $el = $(this);

  var existing = $el.data('flickity');
  if (existing) {
    existing.resize();
    existing.reposition();
    return;
  }

  $el.flickity({
    cellAlign: "left",
    wrapAround: true,
    pageDots: false,
    prevNextButtons: true,
    imagesLoaded: true,
    draggable: false,
    contain: true,
    autoPlay: false,
    pauseAutoPlayOnHover: false
  });
});

// custom js start
(function ($) {
  function updateHeaderHeightVariable() {
    var headerHeight = $('.jsHeader.header-section').outerHeight() || $('header#header').outerHeight() || $('#header').outerHeight() || 0;
    var announcementHeight = $('#shopify-section-announcement-bar').outerHeight() || $('.announcement-sticky-wrapper').outerHeight() || 0;
    var totalHeight = Math.ceil(headerHeight + announcementHeight);

    if (totalHeight > 0) {
      window.eventMeasuredHeaderHeight = totalHeight;
      document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
    } else if (window.eventMeasuredHeaderHeight) {
      document.documentElement.style.setProperty('--header-height', window.eventMeasuredHeaderHeight + 'px');
    }
  }

  function scheduleHeaderHeightUpdate(delay) {
    window.clearTimeout(window.eventHeaderHeightTimer);
    window.eventHeaderHeightTimer = window.setTimeout(updateHeaderHeightVariable, delay || 80);
  }

  function getEventHeaderHeight() {
    var headerHeight = $('.jsHeader.header-section').outerHeight() || $('header#header').outerHeight() || $('#header').outerHeight() || 0;
    var announcementHeight = $('#shopify-section-announcement-bar').outerHeight() || $('.announcement-sticky-wrapper').outerHeight() || 0;

    return Math.ceil(headerHeight + announcementHeight) || window.eventMeasuredHeaderHeight || parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  }

  function setEventNavHeaderOffset(hasHeaderOffset) {
    var $body = $('body');
    var useHeaderOffset = hasHeaderOffset && !$body.hasClass('article-event-cij');
    var offset = useHeaderOffset ? getEventHeaderHeight() : 0;

    if (!$body.hasClass('event-jump-page')) return;

    $body.toggleClass('event-nav-header-offset', useHeaderOffset);
    $('.section-jump-bar-section').toggleClass('has-header-offset', useHeaderOffset);
    document.documentElement.style.setProperty('--event-nav-offset', offset + 'px');
  }

  function updateActiveJumpLink() {
    var $links = $('.section-jump-bar__link');
    if (!$links.length) return;

    var navOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--event-nav-offset')) || 0;
    var navHeight = $('.section-jump-bar-section').outerHeight() || 0;
    var viewportTop = $(window).scrollTop() + navOffset + navHeight;
    var viewportBottom = $(window).scrollTop() + $(window).height();
    var $activeLink = $links.first();
    var activeVisibleRatio = 0;
    var activeVisibleHeight = 0;

    $links.each(function () {
      var selector = $(this).attr('href');
      if (!selector || selector.charAt(0) !== '#') return;

      var $target = $(selector);
      if (!$target.length) return;

      var targetTop = $target.offset().top;
      var targetBottom = targetTop + $target.outerHeight();
      var visibleTop = Math.max(targetTop, viewportTop);
      var visibleBottom = Math.min(targetBottom, viewportBottom);
      var visibleHeight = Math.max(0, visibleBottom - visibleTop);
      var targetHeight = Math.max(1, targetBottom - targetTop);
      var visibleRatio = visibleHeight / Math.min(targetHeight, $(window).height());

      if (visibleRatio > activeVisibleRatio || (visibleRatio === activeVisibleRatio && visibleHeight > activeVisibleHeight)) {
        activeVisibleRatio = visibleRatio;
        activeVisibleHeight = visibleHeight;
        $activeLink = $(this);
      }
    });

    $links.removeClass('is-active').removeAttr('aria-current');
    $activeLink.addClass('is-active').attr('aria-current', 'true');

    if ($activeLink.length && $activeLink[0].scrollIntoView) {
      $activeLink[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function scrollToJumpTarget(targetSelector) {
    var $target = $(targetSelector);
    if (!$target.length) return;

    var navOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--event-nav-offset')) || 0;
    var navHeight = $('.section-jump-bar-section').outerHeight() || 0;
    var targetTop = Math.max(0, $target.offset().top - navOffset - navHeight + 1);

    $('html, body').stop(true).animate({ scrollTop: targetTop }, 750);
  }

  function disableEventPageStickyHeader() {
    if (!$('body').hasClass('article-event-cij')) return;

    if (Shopify.theme.jsHeader && typeof Shopify.theme.jsHeader.disableSticky === 'function') {
      Shopify.theme.jsHeader.disableSticky();
    }

    if (Shopify.theme.mobileMenu && typeof Shopify.theme.mobileMenu.disableSticky === 'function') {
      Shopify.theme.mobileMenu.disableSticky();
    }

    $('#header, #mobile-header').each(function () {
      var $header = $(this);

      if (typeof $header.unstick === 'function') {
        $header.unstick();
      }
    });

    $('#header, #mobile-header')
      .removeClass('sticky--enabled')
      .css({
        position: '',
        top: '',
        width: '',
        height: '',
        'z-index': ''
      });

    $('.header-sticky-wrapper, #mobile-header-sticky-wrapper')
      .removeClass('is-sticky')
      .css({
        height: 'auto',
        minHeight: '',
        position: '',
        top: '',
        width: '',
        'z-index': ''
      });
  }

  function initEventJumpPage() {
    if (!$('.section-jump-bar-section').length) return;

    $('body').addClass('event-jump-page');
    disableEventPageStickyHeader();
    setEventNavHeaderOffset(false);
    updateActiveJumpLink();
  }

  function submitImageTextChecklistAtc($form) {
    var $button = $form.find('.js-image-text-checklist-atc-button');
    var $buttonText = $button.find('.text');
    var $warning = $form.closest('.image-text-checklist__buttons').find('.cart-warning');
    var buttonLabel = $button.data('label') || $buttonText.text();

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $form.serialize(),
      beforeSend: function () {
        $warning.empty();
        $button.attr('disabled', 'disabled').addClass('disabled');
        $buttonText.text('Adding...');
      },
      success: function () {
        $button.find('.checkmark').addClass('checkmark-active');

        if (Shopify.theme.jsAjaxCart) {
          if (typeof Shopify.theme.jsAjaxCart.updateView === 'function') {
            Shopify.theme.jsAjaxCart.updateView();
          }

          if (typeof Shopify.theme.jsAjaxCart.showDrawer === 'function') {
            Shopify.theme.jsAjaxCart.showDrawer();
          }
        }

        window.setTimeout(function () {
          $button.removeAttr('disabled').removeClass('disabled');
          $button.find('.checkmark').removeClass('checkmark-active');
          $buttonText.text(buttonLabel);
        }, 1000);
      },
      error: function (response) {
        var message = 'Unable to add this product to cart.';

        if (response && response.responseJSON && response.responseJSON.description) {
          message = response.responseJSON.description;
        }

        $warning.html(message);
        $button.removeAttr('disabled').removeClass('disabled');
        $buttonText.text(buttonLabel);
      }
    });
  }

  function applyEventCollectionArrows(context) {
    var $context = context ? $(context) : $(document);
    var prevIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31" fill="none" aria-hidden="true" focusable="false"><path d="M18.084 26.89 8.037 15.696 18.084 4.502" stroke="currentColor" stroke-width="2.583" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var nextIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31" fill="none" aria-hidden="true" focusable="false"><path d="m6.028 26.89 10.046-11.194L6.028 4.502" stroke="currentColor" stroke-width="2.583" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    $context.find('.event-featured-collection').add($context.closest('.event-featured-collection')).each(function () {
      var $section = $(this);
      var $slider = $section.find('.featured-collection.layout--slider');
      var $header = $section.find('.header--wrapper').first();
      var $controls = $header.find('.event-featured-collection__controls');

      if (!$slider.length || !$slider.hasClass('flickity-enabled')) {
        $controls.remove();
        return;
      }

      if (!$controls.length) {
        $controls = $('<div class="event-featured-collection__controls" aria-hidden="false"><button type="button" class="event-featured-collection__control event-featured-collection__control--prev" aria-label="Previous products"></button><button type="button" class="event-featured-collection__control event-featured-collection__control--next" aria-label="Next products"></button></div>');
        $header.append($controls);
      }

      $slider.find('.flickity-button').hide();
      $controls.find('.event-featured-collection__control--prev').html(prevIcon).off('click.eventFeaturedCollection').on('click.eventFeaturedCollection', function () {
        $slider.flickity('previous');
      });
      $controls.find('.event-featured-collection__control--next').html(nextIcon).off('click.eventFeaturedCollection').on('click.eventFeaturedCollection', function () {
        $slider.flickity('next');
      });
    });

    $context.find('.event-featured-collection .featured-collection.layout--slider').each(function () {
      var $slider = $(this);
      $slider.find('.flickity-button').hide();
    });
  }

  function equalizeEventProductCards(context) {
    var $context = context ? $(context) : $(document);

    $context.find('.event-featured-collection').add($context.closest('.event-featured-collection')).each(function () {
      var $section = $(this);
      var $cards = $section.find('.event-product-card .product-wrap');
      var maxHeight = 0;

      if (!$cards.length) return;

      $cards.css('min-height', '');
      $cards.each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
      });

      if (maxHeight > 0) {
        $cards.css('min-height', maxHeight + 'px');
      }

      $section.find('.featured-collection.layout--slider.flickity-enabled').each(function () {
        $(this).flickity('resize');
      });
    });
  }

  $(document).on('ready shopify:section:load', function (event) {
    updateHeaderHeightVariable();
    initEventJumpPage();
    applyEventCollectionArrows(event.target);
    equalizeEventProductCards(event.target);
  });

  $(window).on('load', function () {
    updateHeaderHeightVariable();
    initEventJumpPage();
    equalizeEventProductCards(document);
  });

  $(document).on('settle.flickity ready.flickity', '.event-featured-collection .featured-collection.layout--slider', function () {
    applyEventCollectionArrows(document);
    equalizeEventProductCards($(this).closest('.event-featured-collection'));
  });

  window.setTimeout(function () {
    updateHeaderHeightVariable();
    initEventJumpPage();
    applyEventCollectionArrows(document);
    equalizeEventProductCards(document);
  }, 600);

  $(document).on('click', '.section-jump-bar__link', function (event) {
    var targetSelector = $(this).attr('href');

    if (!targetSelector || targetSelector.charAt(0) !== '#') return;

    event.preventDefault();
    setEventNavHeaderOffset(false);
    scrollToJumpTarget(targetSelector);
    history.pushState(null, '', targetSelector);
  });

  $(document).on('submit', '.js-image-text-checklist-atc-form', function (event) {
    event.preventDefault();
    submitImageTextChecklistAtc($(this));
  });

  $(window).on('resize', function () {
    scheduleHeaderHeightUpdate(120);
    disableEventPageStickyHeader();
    setEventNavHeaderOffset($('body').hasClass('event-nav-header-offset'));
    equalizeEventProductCards(document);
    window.clearTimeout(window.eventJumpActiveTimer);
    window.eventJumpActiveTimer = window.setTimeout(updateActiveJumpLink, 120);

    window.clearTimeout(window.eventFeaturedCollectionControlsTimer);
    window.eventFeaturedCollectionControlsTimer = window.setTimeout(function () {
      applyEventCollectionArrows(document);
    }, 220);
  });

  var previousEventScrollTop = $(window).scrollTop();
  $(window).on('scroll', function () {
    var currentScrollTop = $(window).scrollTop();
    var scrollingUp = currentScrollTop < previousEventScrollTop - 6;
    var scrollingDown = currentScrollTop > previousEventScrollTop + 6;

    scheduleHeaderHeightUpdate(40);
    if ($('body').hasClass('event-jump-page')) {
      disableEventPageStickyHeader();

      if ($('body').hasClass('article-event-cij')) {
        setEventNavHeaderOffset(false);
      } else if (currentScrollTop <= 4) {
        setEventNavHeaderOffset(false);
      } else if (scrollingUp) {
        setEventNavHeaderOffset(true);
      } else if (scrollingDown) {
        setEventNavHeaderOffset(false);
      }

      window.clearTimeout(window.eventJumpActiveTimer);
      window.eventJumpActiveTimer = window.setTimeout(updateActiveJumpLink, 60);
    }

    previousEventScrollTop = currentScrollTop;
  });
})(jQuery);
// custom js end
